(function(document, window, $) {
    'use strict';

    var slidePanelHistory = [];

    window.App = Site.extend({
        changeGetParameter: function (url, paramName, paramValue) {
            if (url.indexOf(paramName + "=") >= 0) {
                var prefix = url.substring(0, url.indexOf(paramName));
                var suffix = url.substring(url.indexOf(paramName));
                suffix = suffix.substring(suffix.indexOf("=") + 1);
                suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
                url = prefix + paramName + "=" + paramValue + suffix;
            }
            else {
                if (url.indexOf("?") < 0)
                    url += "?" + paramName + "=" + paramValue;
                else
                    url += "&" + paramName + "=" + paramValue;
            }

            return url;
        },
        handleSlidePanel: function() {
            if (typeof $.slidePanel === 'undefined') return;

            var defaults = $.components.getDefaults("slidePanel");
            var options = window.PanelOptions = $.extend({}, defaults, {
                template: function(options) {
                    return '<div class="' + options.classes.base + ' ' + options.classes.base + '-' + options.direction + '">' +
                        '<div class="' + options.classes.base + '-scrollable"><div>' +
                        '<div class="' + options.classes.content + '"></div>' +
                        '</div></div>' +
                        '<div class="' + options.classes.base + '-handler"></div>' +
                        '</div>';
                },
                afterLoad: function() {
                    this.$panel.find('.' + this.options.classes.base + '-scrollable').asScrollable({
                        namespace: 'scrollable',
                        contentSelector: '>',
                        containerSelector: '>'
                    });
                    window.hadleSlideHistory();
                    window.initSlidePanel(this.$panel);

                },

                afterHide: function() {
                    window.clearSlideHistory();
                    $('.tooltip').hide();
                }


            });



            $(document).on('click', '[data-toggle=slidePanel]', function(e) {


                window.removeTooltips();

                var url =  $(this).data('url');
                window.addToSlideHistory(url);

                openSlide(url);

                e.stopPropagation();
                e.preventDefault();
                if ($(this).hasClass('model-item')) {
                    $('.model-item.active-item-slidepanel').removeClass('active-item-slidepanel');
                    $(this).addClass('active-item-slidepanel');
                }
            });

            $(document).on('click', '[data-toggle=slidePanelData]', function(e) {
                window.removeTooltips();

                var url =  $(this).data('url');
                window.addToSlideHistory(url);

                var data = {};
                if ($(this).data('form') != undefined)
                    data = $('#'+$(this).data('form')).serialize();

                $.slidePanel.show({
                    url: $(this).data('url'),
                    postdata: data,
                    settings: {
                        cache: false
                    }
                }, options);

                e.stopPropagation();
                e.preventDefault();
            });


            $(document).on('click', '#slide-back-history', function(e) {
                var url =  $(this).data('url');
                window.popSlideHistory();
                openSlide(url);
                e.stopPropagation();
                e.preventDefault();
            });

            window.openSlide = function(url){
                $.slidePanel.show({
                    url: url,
                    settings: {
                        cache: false
                    }
                }, options);
            }

        },
        handleMultiSelect: function() {
            var $all = $('.select-all');

            $(document).on('change', '.multi-select', function(e, isSelectAll) {

                if (isSelectAll) return;


                var $select = $('.multi-select'),
                    total = $select.length,
                    checked = $select.find('input:checked').length;
                if (total === checked) {
                    $all.find('input').prop('checked', true);
                } else {
                    $all.find('input').prop('checked', false);
                }
            });

            $all.on('change', function() {
                var checked = $(this).find('input').prop('checked');

                $('.multi-select input').each(function() {
                    $(this).prop('checked', checked).trigger('change', [true]);
                });

            });
        },

        handleListActions: function() {
            $(document).on('click', '[data-toggle="list-editable"]', function() {
                var $btn = $(this),
                    $list = $btn.parents('.list-group-item'),
                    $content = $list.find('.list-content'),
                    $editable = $list.find('.list-editable');

                $content.hide();
                $editable.show();
                $editable.find('input:first-child').focus().select();
            });

            $(document).on('keydown', '.list-editable [data-bind]', function(event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);

                if (keycode == 13 || keycode == 27) {
                    var $input = $(this),
                        bind = $input.data('bind'),
                        $list = $input.parents('.list-group-item'),
                        $content = $list.find('.list-content'),
                        $editable = $list.find('.list-editable'),
                        $update = bind ? $list.find(bind) : $list.find('.list-text');

                    if (keycode == 13) {
                        $update.html($input.val());
                    } else {
                        $input.val($update.text());
                    }

                    $content.show();
                    $editable.hide();
                }
            });

            $(document).on('click', '[data-toggle="list-editable-close"]', function() {
                var $btn = $(this),
                    $list = $btn.parents('.list-group-item'),
                    $content = $list.find('.list-content'),
                    $editable = $list.find('.list-editable');

                $content.show();
                $editable.hide();
            });
        },

        run: function(next) {
            this.handleSlidePanel();
            this.handleListActions();
            //this.handleMultiSelect();
            next();
        }
    });

    window.hadleSlideHistory = function(){

        if (slidePanelHistory.length > 1){
            //console.log('Handle history'+slidePanelHistory);
            var $backButton = $('#slide-back-history');
            $backButton.attr('data-url', slidePanelHistory[slidePanelHistory.length-2]);
            $backButton.removeClass('hidden');
        }
    }

    window.addToSlideHistory = function(url){
        //console.log('added to history'+url);
        slidePanelHistory.push(url);
    }

    window.popSlideHistory = function(){
        //console.log('history pop');
        slidePanelHistory.pop();
    }

    window.clearSlideHistory = function(){
        //console.log('history clear');
        slidePanelHistory = [];
    }


})(document, window, jQuery);
